import { api } from '@services';

import EquipmentStatus, {
  IEquipmentStatus,
  IEquipmentStatusApiModel,
} from '@models/EquipmentStatus.model';

const indexEquipmentStatus = async (): Promise<IEquipmentStatus[]> => {
  const { data: equipmentStatus } = await api.get<IEquipmentStatusApiModel[]>(
    '/equipmentStatus',
  );

  return EquipmentStatus.arrayFromApiModel(equipmentStatus);
};

export { indexEquipmentStatus };
